/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NovitusPaymentChequeDto
 */
export interface NovitusPaymentChequeDto {
    /**
     * Nazwa formy płatności czekiem
     * @type {string}
     * @memberof NovitusPaymentChequeDto
     */
    name: string;
    /**
     * Wartość płatności czekiem
     * @type {string}
     * @memberof NovitusPaymentChequeDto
     */
    value: string;
}

/**
 * Check if a given object implements the NovitusPaymentChequeDto interface.
 */
export function instanceOfNovitusPaymentChequeDto(value: object): value is NovitusPaymentChequeDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function NovitusPaymentChequeDtoFromJSON(json: any): NovitusPaymentChequeDto {
    return NovitusPaymentChequeDtoFromJSONTyped(json, false);
}

export function NovitusPaymentChequeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusPaymentChequeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'value': json['value'],
    };
}

export function NovitusPaymentChequeDtoToJSON(value?: NovitusPaymentChequeDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'value': value['value'],
    };
}

